import { render, staticRenderFns } from "./UserGroupTreeSelector.vue?vue&type=template&id=bd3b6ace&"
import script from "./UserGroupTreeSelector.vue?vue&type=script&lang=js&"
export * from "./UserGroupTreeSelector.vue?vue&type=script&lang=js&"
import style0 from "./UserGroupTreeSelector.vue?vue&type=style&index=0&id=bd3b6ace&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports